import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { withStyles } from '@material-ui/core/styles'
import AdminGeneralComponent from './general/AdminGeneralComponent'
import AdminTaxesComponent from './taxes/AdminTaxesComponent'
import AdminPaymentsComponent from './payments/AdminPaymentsComponent'
// import PropTypes from 'prop-types'
const styles = theme => ({
  rootTabs: {
    flexGrow: 1,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 51
  },
  rootTab: {
    height: 51,
    maxWidth: 'none'
  }
})
export default withStyles(styles)(
  class AdminSettingsComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      showModal: PropTypes.func.isRequired,
      settings: PropTypes.object.isRequired,
      refreshTaxes: PropTypes.func.isRequired,
      refreshPayments: PropTypes.func.isRequired
    }
    state = {
      tabValue: 0
    }
    componentDidMount() {}
    handleChangeTab = (event, value) => {
      this.setState({ tabValue: value })
    }

    render() {
      const {
        classes,
        settings,
        showModal,
        refreshTaxes,
        refreshPayments
      } = this.props
      const { tabValue } = this.state
      return (
        <div style={{ paddingTop: '20px' }}>
          <Tabs
            className={classes.rootTabs}
            value={tabValue}
            onChange={this.handleChangeTab}
            scrollable={false}
            fullWidth
            indicatorColor="secondary">
            <Tab className={classes.rootTab} label="Géneral" />
            <Tab className={classes.rootTab} label="Taux de Tva" />
            <Tab className={classes.rootTab} label="Mode de paiement" />
          </Tabs>
          {tabValue === 0 && (
            <AdminGeneralComponent
              showModal={showModal}
              adminCode={settings.adminCode}
            />
          )}
          {tabValue === 1 && (
            <AdminTaxesComponent
              showModal={showModal}
              refreshTaxes={refreshTaxes}
              taxes={settings.taxes}
            />
          )}
          {tabValue === 2 && (
            <AdminPaymentsComponent
              showModal={showModal}
              refreshPayments={refreshPayments}
              payments={settings.payments}
            />
          )}
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Settings/components/AdminSettingsComponent.js